import client from '../../api';
import { CancelToken } from 'axios';
import qs from 'qs';

// One listing is on screen at a time — switching the "View" filter cancels the request of the view left behind.
let cancel;

const getInitiationsList = async (url, params) => {
  try {
    if (cancel !== undefined) {
      cancel();
    }
    return await client.get(url, {
      params,
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      }),
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    });
  } catch (e) {
    console.log(e);
    return e;
  }
};

// Company-level list of all the initiations of every form in the company.
export const getCorporateInitiationsManagementForms = async (params) =>
  getInitiationsList(`/api/corporate-library/initiations-management/initiated-forms`, params);

// The same listing by task: a task initiation groups the whole set of the task's forms under one row.
export const getCorporateInitiationsManagementTasks = async (params) =>
  getInitiationsList(`/api/corporate-library/initiations-management/task-initiations`, params);

export const getCorporateInitiationsManagementInitiators = async (params) => {
  try {
    return await client.get(`/api/corporate-library/initiations-management/initiated-forms/initiators`, { params });
  } catch (e) {
    console.log(e);
    return e;
  }
};

// The options of the "Submitters from" filter — the company's facilities, the same for both views.
export const getCorporateInitiationsManagementFacilities = async (params) => {
  try {
    return await client.get(`/api/corporate-library/initiations-management/initiated-forms/facilities/`, { params });
  } catch (e) {
    console.log(e);
    return e;
  }
};

export const getCorporateInitiationsManagementTaskInitiators = async (params) => {
  try {
    return await client.get(`/api/corporate-library/initiations-management/task-initiations/initiators`, { params });
  } catch (e) {
    console.log(e);
    return e;
  }
};

// "Stop the initiation" of a task run. A hard stop also removes the forms the run already sent
// out from the submitters' "Forms assigned to me" / "Forms in Progress" folders; a soft stop only
// drops what the run would still initiate, and is offered on a run with a frequency alone.
export const stopCorporateInitiationsManagementTaskInitiation = async (taskInitiationId, hardStop = false) => {
  try {
    return await client.post(`/api/corporate-library/initiations-management/task-initiations/${taskInitiationId}/stop/`, null, {
      params: hardStop ? { hard_stop: true } : undefined,
    });
  } catch (e) {
    console.log(e);
    return e;
  }
};

// "Delete initiation" of a task run: the run goes for good, with the forms it sent out and every
// submission made on them.
export const deleteCorporateInitiationsManagementTaskInitiation = async (taskInitiationId) => {
  try {
    return await client.delete(`/api/corporate-library/initiations-management/task-initiations/${taskInitiationId}/`);
  } catch (e) {
    console.log(e);
    return e;
  }
};

// Everything the task settings popup shows: the initiator, the forms included in the task and the
// settings the initiator gave the task when they ran it.
export const getCorporateInitiationsManagementTaskSettings = async (taskInitiationId) => {
  try {
    return await client.get(`/api/corporate-library/initiations-management/task-initiations/${taskInitiationId}`);
  } catch (e) {
    console.log(e);
    return e;
  }
};
